import { Component, Inject } from '@angular/core'
import { MAT_DIALOG_DATA, MatDialog, MatDialogRef } from '@angular/material/dialog'
import { ButtonComponent } from 'src/app/elements/button/button.component'
import { HttpClient } from '@angular/common/http'
import { PageContext, RedirectorPaynowConfig } from 'src/app/service/redirector.service'
import { PopupComponent } from 'src/app/elements/popup/popup.component'
import { PriceSuggestionComponent } from 'src/app/elements/price-suggestion/price-suggestion.component'

@Component({
  imports: [
    ButtonComponent,
  ],
  selector: 'app-offer-expired-note',
  templateUrl: './offer-expired-note.component.html',
  styleUrl: './offer-expired-note.component.sass',
})
export class OfferExpiredNoteComponent {

  constructor (
    @Inject(MAT_DIALOG_DATA) protected data: PageContext<RedirectorPaynowConfig>,
    @Inject(MatDialogRef) protected dialog: MatDialogRef<PopupComponent>,
    protected http: HttpClient,
    protected dialogSpawn: MatDialog,
  ) {
  }

  offer () {
    this.close()
    this.dialogSpawn.open(PriceSuggestionComponent, {
      maxHeight: '100vh',
      maxWidth: 'calc(100vw - 30px)',
      data: { context: this.data.config },
    })
  }

  close () {
    this.dialog.close()
  }
}
